import React from 'react'
import { useTranslation } from 'react-i18next'

import MultiSelectBox from '../../../features/components/Form/MultiSelectBox'

import { languagesTargetingOptions } from '../../DV360/LineItemForms/LineItemDv360Create/targetingOptions'

const Dv360Languages = ({ name, value, setFieldValue }) => {
  const { t } = useTranslation()

  const formattedLanguages = languagesTargetingOptions.map(item => ({
    label: item.languageDetails?.displayName,
    value: item.targetingOptionId
  }))

  return (
    <MultiSelectBox
      placeholder={t('ADD A LANGUAGE')}
      name={name}
      options={formattedLanguages}
      value={value}
      isLoading={false}
      setFieldValue={setFieldValue}
    />
  )
}

export default Dv360Languages
